class DayJSBuilder {
  constructor() {
    this.dayJS = require("dayjs");
    return this;
  }
  advancedFormat() {
    let plugin = require("dayjs/plugin/advancedFormat");
    this.dayJS.extend(plugin);
    return this;
  }
  customParseFormat() {
    let plugin = require("dayjs/plugin/customParseFormat");
    this.dayJS.extend(plugin);
    return this;
  }
  isBetween() {
    let plugin = require("dayjs/plugin/isBetween");
    this.dayJS.extend(plugin);
    return this;
  }
  build() {
    return this.dayJS;
  }
}

module.exports = new DayJSBuilder();
